import { Network } from '@/Overtime/enums/network'
import type { ContractData } from '@/Overtime/types/viem'

const liveTradingProcessorContract: ContractData = {
  addresses: {
    [Network.OptimismMainnet]: '0xAeab38DA5530dDE6E8aF0Ab80B193aDf6bBD09bb',
    [Network.Arbitrum]: '0x84BCFa2B138B351e177053bA0df21cbCaeCE58f7',
    [Network.Base]: '0x6335697c970454e0bCc0F680E24BB03a35b266a9',
    [Network.OptimismSepolia]: '0xf01554725ad81a5FD959a696642299fA341B67E7',
  },
  abi: [
    {
      inputs: [
        { internalType: 'address', name: '_link', type: 'address' },
        { internalType: 'address', name: '_oracle', type: 'address' },
        { internalType: 'address', name: '_sportsAMM', type: 'address' },
        { internalType: 'bytes32', name: '_jobSpecId', type: 'bytes32' },
        { internalType: 'uint256', name: '_paymentAmount', type: 'uint256' },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      inputs: [{ internalType: 'address', name: 'target', type: 'address' }],
      name: 'AddressEmptyCode',
      type: 'error',
    },
    {
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'AddressInsufficientBalance',
      type: 'error',
    },
    { inputs: [], name: 'EnforcedPause', type: 'error' },
    { inputs: [], name: 'ExpectedPause', type: 'error' },
    { inputs: [], name: 'FailedInnerCall', type: 'error' },
    {
      inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
      name: 'OwnableInvalidOwner',
      type: 'error',
    },
    {
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'OwnableUnauthorizedAccount',
      type: 'error',
    },
    {
      inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
      name: 'SafeERC20FailedOperation',
      type: 'error',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'id', type: 'bytes32' },
      ],
      name: 'ChainlinkCancelled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'id', type: 'bytes32' },
      ],
      name: 'ChainlinkFulfilled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        { indexed: true, internalType: 'bytes32', name: 'id', type: 'bytes32' },
      ],
      name: 'ChainlinkRequested',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: '_link',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'address',
          name: '_oracle',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'address',
          name: '_sportsAMM',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'bytes32',
          name: '_jobSpecId',
          type: 'bytes32',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: '_paymentAmount',
          type: 'uint256',
        },
      ],
      name: 'ContextReset',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'requester',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'bytes32',
          name: 'requestId',
          type: 'bytes32',
        },
        { indexed: false, internalType: 'bool', name: '_allow', type: 'bool' },
        {
          indexed: false,
          internalType: 'bytes32',
          name: '_gameId',
          type: 'bytes32',
        },
        {
          indexed: false,
          internalType: 'uint16',
          name: '_sportId',
          type: 'uint16',
        },
        {
          indexed: false,
          internalType: 'uint16',
          name: '_typeId',
          type: 'uint16',
        },
        { indexed: false, internalType: 'int24', name: '_line', type: 'int24' },
        {
          indexed: false,
          internalType: 'uint8',
          name: '_position',
          type: 'uint8',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: '_buyInAmount',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: '_expectedQuote',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'address',
          name: '_collateral',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'timestamp',
          type: 'uint256',
        },
      ],
      name: 'LiveTradeFulfilled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'requester',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'requestCounter',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'bytes32',
          name: 'requestId',
          type: 'bytes32',
        },
        {
          indexed: false,
          internalType: 'bytes32',
          name: '_gameId',
          type: 'bytes32',
        },
        {
          indexed: false,
          internalType: 'uint16',
          name: '_sportId',
          type: 'uint16',
        },
        {
          indexed: false,
          internalType: 'uint16',
          name: '_typeId',
          type: 'uint16',
        },
        { indexed: false, internalType: 'int24', name: '_line', type: 'int24' },
        {
          indexed: false,
          internalType: 'uint8',
          name: '_position',
          type: 'uint8',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: '_buyInAmount',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: '_expectedQuote',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'address',
          name: '_collateral',
          type: 'address',
        },
      ],
      name: 'LiveTradeRequested',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Paused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: '_freeBetsHolder',
          type: 'address',
        },
      ],
      name: 'SetFreeBetsHolder',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: '_maxAllowedExecutionDelay',
          type: 'uint256',
        },
      ],
      name: 'SetMaxAllowedExecutionDelay',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: '_stakingThalesBettingProxy',
          type: 'address',
        },
      ],
      name: 'SetStakingThalesBettingProxy',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Unpaused',
      type: 'event',
    },
    {
      inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      name: 'counterToRequestId',
      outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'bytes32', name: '_requestId', type: 'bytes32' },
        { internalType: 'bool', name: '_allow', type: 'bool' },
        { internalType: 'uint256', name: '_approvedQuote', type: 'uint256' },
      ],
      name: 'fulfillLiveTrade',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: 'requestId', type: 'bytes32' }],
      name: 'getTradeData',
      outputs: [
        {
          components: [
            { internalType: 'string', name: '_gameId', type: 'string' },
            { internalType: 'uint16', name: '_sportId', type: 'uint16' },
            { internalType: 'uint16', name: '_typeId', type: 'uint16' },
            { internalType: 'int24', name: '_line', type: 'int24' },
            { internalType: 'uint8', name: '_position', type: 'uint8' },
            { internalType: 'uint256', name: '_buyInAmount', type: 'uint256' },
            {
              internalType: 'uint256',
              name: '_expectedQuote',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: '_additionalSlippage',
              type: 'uint256',
            },
            { internalType: 'address', name: '_referrer', type: 'address' },
            { internalType: 'address', name: '_collateral', type: 'address' },
          ],
          internalType: 'struct ILiveTradingProcessor.LiveTradeData',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'jobSpecId',
      outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'maxAllowedExecutionDelay',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paymentAmount',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'requestCounter',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'requestIdFulfilled',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'requestIdToFulfillAllowed',
      outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'requestIdToRequester',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'requestIdToTicketId',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'requestIdToTradeData',
      outputs: [
        { internalType: 'string', name: '_gameId', type: 'string' },
        { internalType: 'uint16', name: '_sportId', type: 'uint16' },
        { internalType: 'uint16', name: '_typeId', type: 'uint16' },
        { internalType: 'int24', name: '_line', type: 'int24' },
        { internalType: 'uint8', name: '_position', type: 'uint8' },
        { internalType: 'uint256', name: '_buyInAmount', type: 'uint256' },
        { internalType: 'uint256', name: '_expectedQuote', type: 'uint256' },
        {
          internalType: 'uint256',
          name: '_additionalSlippage',
          type: 'uint256',
        },
        { internalType: 'address', name: '_referrer', type: 'address' },
        { internalType: 'address', name: '_collateral', type: 'address' },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          components: [
            { internalType: 'string', name: '_gameId', type: 'string' },
            { internalType: 'uint16', name: '_sportId', type: 'uint16' },
            { internalType: 'uint16', name: '_typeId', type: 'uint16' },
            { internalType: 'int24', name: '_line', type: 'int24' },
            { internalType: 'uint8', name: '_position', type: 'uint8' },
            { internalType: 'uint256', name: '_buyInAmount', type: 'uint256' },
            {
              internalType: 'uint256',
              name: '_expectedQuote',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: '_additionalSlippage',
              type: 'uint256',
            },
            { internalType: 'address', name: '_referrer', type: 'address' },
            { internalType: 'address', name: '_collateral', type: 'address' },
          ],
          internalType: 'struct ILiveTradingProcessor.LiveTradeData',
          name: '_liveTradeData',
          type: 'tuple',
        },
      ],
      name: 'requestLiveTrade',
      outputs: [
        { internalType: 'bytes32', name: 'requestId', type: 'bytes32' },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: '_link', type: 'address' },
        { internalType: 'address', name: '_oracle', type: 'address' },
        { internalType: 'address', name: '_sportsAMM', type: 'address' },
        { internalType: 'bytes32', name: '_jobSpecId', type: 'bytes32' },
        { internalType: 'uint256', name: '_paymentAmount', type: 'uint256' },
      ],
      name: 'setConfiguration',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: '_freeBetsHolder', type: 'address' },
      ],
      name: 'setFreeBetsHolder',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_maxAllowedExecutionDelay',
          type: 'uint256',
        },
      ],
      name: 'setMaxAllowedExecutionDelay',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bool', name: '_setPausing', type: 'bool' }],
      name: 'setPaused',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_stakingThalesBettingProxy',
          type: 'address',
        },
      ],
      name: 'setStakingThalesBettingProxy',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'sportsAMM',
      outputs: [
        { internalType: 'contract ISportsAMMV2', name: '', type: 'address' },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'stakingThalesBettingProxy',
      outputs: [{ internalType: 'address', name: '', type: 'address' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
      name: 'timestampPerRequest',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        { internalType: 'address', name: 'collateral', type: 'address' },
        { internalType: 'address', name: 'recipient', type: 'address' },
      ],
      name: 'withdrawCollateral',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ],
}

export default liveTradingProcessorContract
